import { render, staticRenderFns } from "./CabinetFooter.vue?vue&type=template&id=42ca1416&scoped=true"
import script from "./CabinetFooter.vue?vue&type=script&lang=ts"
export * from "./CabinetFooter.vue?vue&type=script&lang=ts"
import style0 from "./CabinetFooter.vue?vue&type=style&index=0&id=42ca1416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca1416",
  null
  
)

export default component.exports